const PROVIDER_CONFIG = {
  '9bb58a76-89cc-4085-98ad-f14b6fe90a38': {
    name: 'Dr. Kantha',
    type: 'phone',
    phone: '201-445-7744',
  },
  '733ed709-6536-4d8c-b8c3-fab6fcadd4c8': {
    name: 'Dr. Miller',
    type: 'doxy',
    doxyUrl: 'https://drjcmiller.doxy.me/mmj',
  },
};

export default PROVIDER_CONFIG;
